import React from 'react';
import dayjs from 'dayjs';
import { ReferenceLine } from 'recharts';

import { LegendItem } from './ChartLegend';
import { WEEKEND_LINE_COLOR } from './chartTheme';
import { TimeBucket } from '../../utils/statistics';

const SATURDAY = 6;
const SUNDAY = 0;

export const isWeekendBucket = (bucket: Pick<TimeBucket, 'date' | 'unit'>) =>
  bucket.unit === 'day' &&
  [SATURDAY, SUNDAY].includes(dayjs(bucket.date).day());

/**
 * Dotted vertical lines through Saturdays and Sundays of a per-day chart.
 * Returned as an array because recharts only reads its direct children.
 */
export const renderWeekendLines = (
  data: (Pick<TimeBucket, 'key' | 'date' | 'unit'> & { label: string })[]
) =>
  data.filter(isWeekendBucket).map((point) => (
    <ReferenceLine
      key={`weekend-${point.key}`}
      x={point.label}
      stroke={WEEKEND_LINE_COLOR}
      strokeWidth={1.5}
      strokeDasharray="2 3"
      ifOverflow="extendDomain"
    />
  ));

export const getWeekendLegendItem = (
  buckets: Pick<TimeBucket, 'date' | 'unit'>[],
  label: string
): LegendItem[] =>
  buckets.some(isWeekendBucket)
    ? [{ key: 'weekend', label, color: WEEKEND_LINE_COLOR, swatch: 'dotted' }]
    : [];
